import { TabPanel, TabPanelLocation } from '@tabeeb/enums'
import { handleActions } from 'redux-actions'
import * as sessionTabsActions from '../actions'

export type SessionPanelState = {
  name: TabPanel
  expanded?: boolean
}

export type SessionPanelsState = {
  left: SessionPanelState | null
  right: SessionPanelState | null
  bottom: SessionPanelState | null
}

const initialState: SessionPanelsState = {
  left: null,
  right: {
    name: TabPanel.Gallery,
    expanded: false,
  },
  bottom: null,
}

const switchPanel = (
  state: SessionPanelsState,
  { panel, location }: { panel: SessionPanelState; location: TabPanelLocation }
) => {
  const newState = { ...state }
  newState[location] = state[location]?.name === panel.name ? null : panel
  if (newState[location]) {
    newState[location].expanded = panel.expanded ?? false
  }
  return {
    ...newState,
  }
}

const togglePanel = (state: SessionPanelsState, panel: TabPanel, expanded: boolean) => {
  const found = Object.entries(state).find(([, p]) => p?.name === panel)

  if (!found) {
    return state
  }

  const [key, p] = found
  return {
    ...state,
    [key]: { ...p, expanded },
  }
}

export default handleActions<SessionPanelsState, any>(
  {
    [sessionTabsActions.switchPanel.toString()](state: SessionPanelsState, action: any) {
      return switchPanel(state, action.payload)
    },
    [sessionTabsActions.expandPanel.toString()](state: SessionPanelsState, action: any) {
      const { panel } = action.payload
      return togglePanel(state, panel, true)
    },
    [sessionTabsActions.collapsePanel.toString()](state: SessionPanelsState, action: any) {
      const { panel } = action.payload
      return togglePanel(state, panel, false)
    },
    [sessionTabsActions.resetNavbarState.toString()]() {
      return { ...initialState }
    },
    [sessionTabsActions.setNavbarDefaultState.toString()](state: SessionPanelsState, action: any) {
      const defaultPanelsState = action.payload
      return { ...initialState, currentPanel: { ...defaultPanelsState } }
    },
  },
  initialState
)
